import { Link } from "react-router-dom";

/**
 * Logo, official transparent PNG, sized prominently.
 *
 * Per brand "Clean Space" rules: never distort (h sets the size, w auto),
 * generous padding via the link container, and a tagline beside / under
 * on supported sizes.
 *
 * Props:
 * - variant: "light" (default) | "dark", dark inverts the PNG to white
 * - size: "sm" | "md" | "lg", controls image height
 * - showTagline: render the brand tagline next to / under the mark
 */
export const BRAND_TAGLINE = "Elevating Wellness Through Exceptional Care";

const SIZE_CLASSES = {
 sm: "h-12 sm:h-14",
 md: "h-14 sm:h-16",
 lg: "h-16 sm:h-20",
 xl: "h-20 sm:h-24",
 "2xl": "h-[85px] sm:h-[99px]",
};

export function Logo({ className = "", variant = "light", size = "md", showTagline = false, taglineClassName = "" }) {
 const isDark = variant === "dark";
 return (
 <Link
 to="/"
 data-testid="brand-logo"
 aria-label="Golden Life Standard Health, home"
 className={`group inline-flex items-center gap-3 sm:gap-4 ${className}`}
 >
 <img
 src="/brand/logo.png"
 alt="Golden Life Standard Health"
 className={`${SIZE_CLASSES[size]} w-auto select-none transition duration-300 ${isDark ? "brightness-0 invert" : ""}`}
 style={{ imageRendering: "auto" }}
 loading="eager"
 decoding="async"
 />
 {showTagline && (
 <span
 data-testid="brand-tagline"
 className={`hidden md:inline-block font-serif-italic text-sm sm:text-base leading-snug max-w-[220px] ${isDark ? "text-cream/85" : "text-forest-700"} ${taglineClassName}`}
 >
 {BRAND_TAGLINE}
 </span>
 )}
 </Link>
 );
}
